const readableLocalDateTimeOptions = {
  locale: 'en-SG',
  dateTimeString: {
    locale: 'en-SG',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    weekday: 'short'
  },
  dateString: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  },
  dateWeekdayString: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    weekday: 'short'
  },
  timeString: {
    hour: 'numeric',
    minute: 'numeric'
  }
}

export default readableLocalDateTimeOptions



// WEBPACK FOOTER //
// ./src/readableLocalDateTimeOptions.js